import React, {useEffect, useState} from 'react';
import GooglePlacesAutocomplete, {
  geocodeByPlaceId,
} from 'react-google-places-autocomplete';
import {getAddressComponent} from '../../util/GoogleMapsAddressUtils';
import {GMAPS_API_KEY} from '../../constants';
import {Box, Grid, Typography} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import BidmiiTextField from '../../common/StyledComponents/BidmiiTextField';
import {DoneAll} from '@mui/icons-material';
import {theme} from '../../Theme';
import {isEmpty} from 'lodash';

const styles = () => ({
  root: {
    '& .google-places-autocomplete__input': {
      width: '100%',
      height: 40,
      marginBottom: 16,
      borderRadius: 22,
      fontFamily: 'AeonikProReqular',
      backgroundColor: theme.palette.gray.main,
      boxShadow: 'none',

      '&:focus': {
        border: `1px solid ${theme.palette.primary.main}`,
      },
    },
  },

  manualSwitch: {
    '& .MuiTypography-body1': {
      fontSize: 13,
    },
  },
});
const useStyles = makeStyles(styles);

const LocationForm = (props: $TSFixMe) => {
  const classes = useStyles();
  const [location, setLocation] = useState<any | null>(null);
  const [autocompletionRequest] = useState({
    componentRestrictions: {country: ['ca']},
    types: ['address'],
  });

  const onAddressSelection = (location: $TSFixMe) => {
    geocodeByPlaceId(location.value.place_id).then((res) => {
      process.env.NODE_ENV === 'development' && console.log('res :>> ', res);
      props.setDirty && props.setDirty(true);
      props.dispatch({
        field: 'postal',
        payload: getAddressComponent(res, 'postal_code'),
      });
      props.dispatch({
        field: 'street',
        payload: res[0].formatted_address.split(',')[0],
      });
      props.dispatch({
        field: 'city',
        payload:
          getAddressComponent(res, 'locality') ||
          getAddressComponent(res, 'administrative_area_level_3') ||
          getAddressComponent(res, 'administrative_area_level_2'),
      });
      props.dispatch({
        field: 'province',
        payload: getAddressComponent(res, 'administrative_area_level_1'),
      });
      props.dispatch({field: 'lat', payload: res[0].geometry.location.lat()});
      props.dispatch({field: 'lng', payload: res[0].geometry.location.lng()});
    });
  };

  useEffect(() => {
    if (location?.value.place_id) {
      onAddressSelection(location);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const handleTextChange = (e: $TSFixMe) => {
    props.setDirty && props.setDirty(true);
    props.dispatch({
      field: e.target.name,
      payload: e.target.value,
    });
  };

  const formMapping = {
    street: {aria: 'Street', label: 'STREET'},
    city: {aria: 'City', label: 'CITY'},
    province: {aria: 'Province', label: 'PROVINCE'},
    postal: {aria: 'Postal', label: 'POSTAL CODE'},
  };

  const formItems = Object.keys(formMapping).map((key) => (
    <BidmiiTextField
      key={key}
      name={key}
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      label={formMapping[key].aria}
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      aria-describedby={formMapping[key].aria}
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      placeholder={formMapping[key].label}
      type="text"
      //defaultValue={user?.street}
      id={key}
      onChange={(event) => handleTextChange(event)}
      onBlur={() => props.validateField(key)}
      helperText={props.validator.message(key, props.address[key], 'required', {
        className: 'text-danger',
      })}
      InputLabelProps={{shrink: true}}
      value={props.address[key] || ''}
      disabled={props.address[key] && key !== 'postal'}
      fullWidth
      gutterBottom
    />
  ));

  return (
    <div className={classes.root}>
      {!props.hideInput && (
        <>
          <GooglePlacesAutocomplete
            apiKey={GMAPS_API_KEY}
            selectProps={{
              value: location,
              onChange: setLocation,
              placeholder: 'Start typing to look up address',
              styles: {
                placeholder: (provided: any) => ({
                  ...provided,
                  fontSize: 14,
                }),
                container: (provided: any) => ({
                  ...provided,
                  height: 37,
                  marginBottom: 16,
                }),
                control: (provided: any) => ({
                  ...provided,
                  backgroundColor: theme.palette.gray.main,
                  fontFamily: 'AeonikProReqular',
                  borderRadius: '50px',
                  boxShadow: 'none',
                  border: 'none',
                  borderColor: theme.palette.gray.border,
                  cursor: 'text',
                  '&:hover': {
                    borderWidth: 2,
                    borderColor: theme.palette.primary.light,
                  },
                }),
              },
            }}
            autocompletionRequest={autocompletionRequest}
          />
          <Typography variant="caption" style={{color: theme.palette.red.dark}}>
            {props.validator.message(
              'address',
              props.address.street,
              'required',
            )}
          </Typography>
        </>
      )}
      {!props.onlyText ? (
        formItems
      ) : !isEmpty(props.address) && props.address.street ? (
        <Grid container style={{marginTop: -8}}>
          <DoneAll fontSize="small" style={{color: theme.palette.green.main}} />
          <Box ml={1}>
            <Typography variant="subtitle2">{props.address.street},</Typography>
            <Typography variant="subtitle2">
              {props.address.city}, {props.address.province}
            </Typography>
            <Typography variant="subtitle2">{props.address.postal}</Typography>
          </Box>
        </Grid>
      ) : null}
    </div>
  );
};
export default LocationForm;
